export default defineNuxtPlugin((nuxtApp) => {
  const { $mixpanel, $posthog } = nuxtApp;
  const pageOpenTime = (window as any).__aoPageOpenTime as number | undefined;

  const shouldSkipMixpanel = (() => {
    try {
      const search = window.location.search;
      if (!search) {
        return false;
      }

      return new URLSearchParams(search).get('mixmin') === '1';
    } catch {
      return false;
    }
  })();

  if (!pageOpenTime || shouldSkipMixpanel) return;

  const payload = {
    bundle_download_ms: Date.now() - pageOpenTime,
  };

  $mixpanel.track('Bundle Downloaded', payload);
  $posthog?.capture('Bundle Downloaded', payload);
});
